import $http from './http';

//登录
export const submitLogin = data => {
    return $http.post('/v1/login/login', data);
};

// 退出系统
export const logout = data => {
    return $http.post('/v1/system/logout', data);
};


// 组织架构
export const depart = (params, method, id) => {
    return $http[`${method}`](
        id ? '/v1/depart/' + id : '/v1/depart',
        method == 'get' ? { params: params } : params
    );
};

// 组织架构信息
export const architecture = (params, method, id) => {
    return $http[`${method}`](
        id ? '/v1/depart/architecture/' + id : '/v1/depart/architecture',
        method == 'get' ? { params: params } : params
    );
};

// 天气
export const weather = (params, method, id) => {
    return $http[`${method}`](
        id ? '/v1/system/weather/' + id : '/v1/system/weather',
        method == 'get' ? { params: params } : params
    );
};

// 部门 - 员工  级联
export const departUser = (params, method, id) => {
    return $http[`${method}`](
        id ? "/v1/depart/user/" + id : "/v1/depart/user",
        method == "get" ? { params: params } : params
    );
};

//配置信息公共接口
export const gconf = (params, method, id) => {
    return $http[`${method}`](
        id ? '/v1/config/gconf/' + id : '/v1/config/gconf',
        method == 'get' ? { params: params } : params
    );
};

// 员工
export const user = (params, method, id) => {
    return $http[`${method}`](
        id ? '/v1/user/' + id : '/v1/user',
        method == 'get' ? { params: params } : params
    );
};